<template>
  <color-picker
    :label="$t('edit.sidebar.background_color')"
    :id="getId()"
    :value="value()"
    :change="onColorChange"
    :move="onMove"
  ></color-picker>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ColorPicker from '../../../../general/ColorPicker.vue';

const defaultValue = '#FFFFFF';

export default {
  props: [
    'item',
    'general',
  ],
  components: {
    ColorPicker,
  },
  methods: {
    getId() {
      return `backgroundColor-${this.item}`;
    },
    value() {
      const style = this.stepStyle(this.item);

      if (!style || !style.backgroundColor) {
        return defaultValue;
      }

      return style.backgroundColor.replace('px', '');
    },
    onColorChange(color) {
      if (this.general) {
        return this.quizUpdateStyle({
          item: this.item,
          rule: 'backgroundColor',
          value: color,
        });
      }

      return this.stepUpdateStyle({
        item: this.item,
        rule: 'backgroundColor',
        value: color,
      });
    },
    onMove(color) {
      if (this.general) {
        return this.quizPreviewStyleChange({
          item: this.item,
          rule: 'backgroundColor',
          value: color,
        });
      }

      return this.stepPreviewStyleChange({
        item: this.item,
        rule: 'backgroundColor',
        value: color,
      });
    },
    ...mapActions([
      'quizUpdateStyle',
      'quizPreviewStyleChange',
      'stepUpdateStyle',
      'stepPreviewStyleChange',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** BackgroundColor.vue?2bcd255c
 **/